import React from 'react'
import AgendamentoRelatorioListPageContainer from './AgendamentoRelatorioListPageContainer'

export class AgendamentoRelatorioListPage extends React.Component {
  render() {
    return <AgendamentoRelatorioListPageContainer {...this.props} />
  }
}
